export { default as Fail3D } from './fail-3d.png';
export { default as Success3D } from './success-3d.png';
